import { useState } from 'react';
import { AgeGateOverlay } from '@hypneuronerd/age-gate';
import { useDailyWord } from './hooks/useDailyWord';
import { isEvening } from './lib/dates';
import { ReturnLink } from './components/ReturnLink';
import { Triptych } from './components/Triptych';
import { HeldWord } from './components/HeldWord';
import { EveningReflection } from './components/EveningReflection';
import { TheBook } from './components/TheBook';
import styles from './App.module.css';

type View = 'today' | 'book';

export function App() {
  const {
    today,
    locked,
    quality,
    offered,
    history,
    todayReflection,
    choose,
    refreshTriptych,
    saveReflection,
  } = useDailyWord();
  const [view, setView] = useState<View>('today');

  return (
    <>
      <AgeGateOverlay />
      <header className={styles.topNav}>
        <ReturnLink />
        <nav className={styles.viewSwitcher} aria-label="view">
          <button
            type="button"
            className={`${styles.tab} ${view === 'today' ? styles.tabActive : ''}`}
            onClick={() => setView('today')}
          >
            today
          </button>
          <button
            type="button"
            className={`${styles.tab} ${view === 'book' ? styles.tabActive : ''}`}
            onClick={() => setView('book')}
          >
            the book{history.length > 0 ? ` (${history.length})` : ''}
          </button>
        </nav>
      </header>

      <main className={styles.stage}>
        {view === 'book' && (
          <TheBook history={history} onBack={() => setView('today')} />
        )}

        {view === 'today' && !locked && (
          <Triptych words={offered} onChoose={choose} onRefresh={refreshTriptych} />
        )}

        {view === 'today' && locked && quality && (
          <div className={styles.heldWrap}>
            <HeldWord quality={quality} dateStr={today} />
            {isEvening() && (
              <EveningReflection
                word={quality.word}
                initial={todayReflection}
                onSave={saveReflection}
              />
            )}
          </div>
        )}
      </main>

      <footer className={styles.footer}>
        <p>nothing here leaves your browser.</p>
      </footer>
    </>
  );
}
